import { useState } from 'react';
import { Button } from 'shared-components';
import { close, open } from '../modal/modalSlice';
import { ButtonTier } from 'shared-components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useRequestUnpackMutation } from './archives.api';
import { FormGroup } from 'shared-components';
import { selectTokenPayload } from '../login/authSlice';

export const ArchiveUnpackModal = ({
  filename,
  eventId,
}: {
  filename: string;
  eventId: string;
}) => {
  const dispatch = useAppDispatch();
  const tokenData = useAppSelector(selectTokenPayload);
  const [overwrite, setOverwrite] = useState<boolean>(false);
  const [requestUnpack] = useRequestUnpackMutation();
  return (
    <>
      <FormGroup
        style={{
          marginBottom: '16px',
        }}
      >
        <input
          onChange={(evt) => {
            setOverwrite(evt.target.checked);
          }}
          type="checkbox"
          id="overwrite"
          defaultChecked={false}
        />
        <label htmlFor="overwrite">Overwrite?</label>
      </FormGroup>
      <Button
        onClick={async () => {
          const { tid } = await requestUnpack({
            archiveCloudFilename: filename,
            eventId,
            overwrite,
            accountId: tokenData?.accountId.toString() || '',
          }).unwrap();

          dispatch(close());
          dispatch(
            open({
              title: `Unpacking ${filename}...`,
              contentKey: 'archive-unpacking-modal',
              contentPayload: {
                taskId: tid,
                archiveName: filename,
              },
            })
          );
        }}
      >
        Unpack
      </Button>
      <Button
        tier={ButtonTier.Tertiary}
        onClick={() => {
          dispatch(close());
        }}
      >
        Cancel
      </Button>
    </>
  );
};
